import type { PropsWithChildren, ReactNode } from 'react';

import { BulletedListItemStyled } from './styles/BulletedListItemStyled'
import { Icon, type IconTypes } from '../../../../elements/Icon'
import { Space } from '../../../../elements/Space'

export interface IBulletedListItemProps {
  icon?: IconTypes
  iconComponent?: ReactNode
}

export const BulletedListItem = ({
  icon,
  iconComponent,
  children,
}: PropsWithChildren<IBulletedListItemProps>) => {
  return (
    <BulletedListItemStyled showBullet={!icon && !iconComponent}>
      <Space direction='horizontal'>
        {icon ? <Icon icon={icon} /> : iconComponent ? iconComponent : null}
        <>{children}</>
      </Space>
    </BulletedListItemStyled>
  )
}
